
import React from 'react';
import { CheckCircle2, Target, Brain, BarChart } from 'lucide-react';
import InfoItem from './InfoItem';

const InfoBar = () => {
  const infoItems = [
    {
      icon: CheckCircle2,
      iconColor: "text-green-600",
      bgColor: "bg-green-50",
      shadowColor: "shadow-green-100/60",
      title: "Confidence Under Pressure",
      subtitle: "Reduce Exam Anxiety"
    },
    {
      icon: Target,
      iconColor: "text-primary",
      bgColor: "bg-purple-50",
      shadowColor: "shadow-purple-100/60",
      title: "Targeted Practice",
      subtitle: "Focus on Key Areas"
    },
    {
      icon: Brain,
      iconColor: "text-amber-600",
      bgColor: "bg-amber-50",
      shadowColor: "shadow-amber-100/60",
      title: "Exam-Day Readiness",
      subtitle: "Real Exam Environment"
    },
    {
      icon: BarChart,
      iconColor: "text-purple-600",
      bgColor: "bg-purple-50",
      shadowColor: "shadow-purple-100/60",
      title: "Detailed Feedback",
      subtitle: "Actionable Insights"
    }
  ];

  return (
    <div className="mt-8 bg-white/95 backdrop-blur-xl rounded-xl shadow-sm py-5 px-2 md:px-4 w-full border border-slate-100">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3">
        {infoItems.map((item, index) => (
          <InfoItem 
            key={index}
            icon={item.icon}
            iconColor={item.iconColor}
            bgColor={item.bgColor}
            shadowColor={item.shadowColor}
            title={item.title}
            subtitle={item.subtitle}
          />
        ))}
      </div>
    </div>
  );
};

export default InfoBar;
